import SectionCard from '@/components/molecule/SectionCard';
import { FormField } from '../../ui/form';
import { UseFormReturn } from 'react-hook-form';
import SectionLabel from '../../molecule/SectionLabel';

interface DetailSectionContent {
  name: string | string[];
  placeholder?: string | [string, string];
  label: string;
  isRequired?: boolean;
  render?:
    | ((
        form: UseFormReturn<any, any, any>,
        name: string,
        label: string,
        isRequired?: boolean,
        placeholder?: string,
      ) => React.ReactNode)
    | ((
        form: UseFormReturn<any, any, any>,
        name: [string, string],
        label: string,
        isRequired?: boolean,
        placeholder?: [string, string],
      ) => React.ReactNode);
}

interface FormSectionProps<T extends UseFormReturn<any, any, any>> {
  sectionTitle?: React.ReactNode;
  form: T;
  contents: DetailSectionContent[][];
}

export default function FormSection<T extends UseFormReturn<any, any, any>>({
  sectionTitle,
  form,
  contents,
}: FormSectionProps<T>) {
  const renderSectionGridStyle = () => {
    let resultStyle = '';

    for (let i = 0; i < contents.length; i++) {
      if (i === contents.length - 1) {
        resultStyle += '1fr';
      } else {
        resultStyle += '1fr auto ';
      }
    }

    return resultStyle;
  };

  return (
    <SectionCard cardTitle={sectionTitle}>
      <div
        style={{ gridTemplateColumns: renderSectionGridStyle() }}
        className="grid gap-x-6 gap-y-4"
      >
        {contents.map((content, contentIdx) => (
          <>
            <div
              className="col-span-1 flex flex-col gap-y-6"
              key={contentIdx.toString()}
            >
              {content.map((item, idx) => {
                if (!item.render) {
                  return (
                    <FormField
                      key={idx.toString()}
                      control={form.control}
                      name="text"
                      render={({ field }) => {
                        return (
                          <SectionLabel label="text" value={field.value} />
                        );
                      }}
                    />
                  );
                }

                return item.render(
                  form,
                  item.name as string & [string, string],
                  item.label,
                  item.isRequired,
                  item.placeholder as string & [string, string],
                );
              })}
            </div>
            {contentIdx !== contents.length - 1 && (
              <div className="border-r border-r-gray1" />
            )}
          </>
        ))}
      </div>
    </SectionCard>
  );
}
